export const AGENDA_KINDS = [
  { key: "outlook", label: "Impegno personale", block: "border-slate-400 bg-slate-100 hover:bg-slate-200", dot: "bg-slate-400" },
  { key: "appuntamento", label: "Appuntamento CRM", block: "border-brand-500 bg-brand-50 hover:bg-brand-100", dot: "bg-brand-500" },
  { key: "chiamata", label: "Chiamata", block: "border-sky-500 bg-sky-50 hover:bg-sky-100", dot: "bg-sky-500" },
  { key: "task", label: "Task", block: "border-emerald-500 bg-emerald-50 hover:bg-emerald-100", dot: "bg-emerald-500" },
  { key: "follow_up", label: "Follow-up", block: "border-amber-500 bg-amber-50 hover:bg-amber-100", dot: "bg-amber-500" },
  { key: "email", label: "Email", block: "border-indigo-500 bg-indigo-50 hover:bg-indigo-100", dot: "bg-indigo-500" },
  { key: "intervento", label: "Intervento tecnico", block: "border-rose-600 bg-rose-50 hover:bg-rose-100", dot: "bg-rose-600" },
];

const BY_KEY = Object.fromEntries(AGENDA_KINDS.map((k) => [k.key, k]));

export const agendaKey = (e) => {
  if (e.kind === "intervention" || e.intervention_id) return "intervento";
  if (e.kind === "activity") return BY_KEY[e.type] ? e.type : "task";
  return e.origin === "onsuite" ? "appuntamento" : "outlook";
};

export const agendaStyle = (e) => BY_KEY[agendaKey(e)];

export const isDone = (e) => e.status === "completata" || e.status === "annullata";
